"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLotteryTicketsHistory = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useLotteryTicketsHistory = function (_a) {
    var lotteryId = _a.lotteryId;
    var _b = (0, useQuery_1.useQuery)({
        canRender: !!lotteryId,
        path: keys_1.GET_LOTTERY_TICKETS_HISTORY,
        revalidateOnMount: true,
        payload: {
            input: {
                lotteryId: lotteryId,
            },
        },
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, isValidating = _b.isValidating;
    return {
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    };
};
exports.useLotteryTicketsHistory = useLotteryTicketsHistory;
